<section class="hero-slider">
    <div class="f-slider-three">
        <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let slide of slideStore">
                <ng-template carouselSlide>
                    <div class="hero-section-three gap item"
                         [style.backgroundImage]="'url(' + slide.image + ')'">
                        <div class="container">
                            <div class="hero-three">
                                <h1 [innerHTML]="slide.title"></h1>
                                <p>{{ slide.subtitle }}</p>
                                <a href="#"
                                   class="theme-btn"
                                   data-bs-toggle="modal"
                                   data-bs-target="#exampleModal">{{ slide.btnText }}</a>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
</section>
